import type { AuthBackend, Session, SignOutArgs } from "../types";
import { getAuthHeaders } from "./attachToken";
import { getSession } from "./getSession";
import { signIn, signInWithRedirect } from "./signIn";
import { signOut } from "./signOut";

export class AmplifyAuthBackend implements AuthBackend {
  readonly id = "amplify" as const;
  readonly navigatesOnSignOut = false;

  signIn(args: { email: string; password: string }): Promise<void> {
    return signIn(args);
  }

  signInWithRedirect(args?: { returnTo?: string; idpIdentifier?: string }): Promise<void> {
    return signInWithRedirect(args);
  }

  signOut(args?: SignOutArgs): Promise<void> {
    return signOut(args);
  }

  getSession(): Promise<Session | null> {
    return getSession();
  }

  getAuthHeaders(): Promise<Record<string, string>> {
    return getAuthHeaders();
  }

  shouldUseCredentialsInclude(): boolean {
    return true;
  }
}

export const amplifyAuthBackend = new AmplifyAuthBackend();
